import { useCallback } from "react"
// context
import { useModal } from "context/ModalContext/ModalContext"
import useAuthenticationContext from "context/Authentication/useAuthenticationContext"
// api
import { getExternalCertificateCheckoutSession } from "api"
// constants
import { MODALS } from "constants/modals"

const useExternalCertificateCheckoutModal = (): {
  handleOpenExternalCertificateCheckout: (superCourseId: number) => void
} => {
  const { openModal, closeModal } = useModal()
  const {
    user: { id: userId },
  } = useAuthenticationContext()

  const handleOpenExternalCertificateCheckout = useCallback(
    (superCourseId: number) => {
      openModal(MODALS.TEST.EXTERNAL_CERTIFICATE_CHECKOUT, {
        onContinue: async () => {
          try {
            const { url } = await getExternalCertificateCheckoutSession({
              userId,
              superCourseId,
              returnPath: window.location.pathname,
            })

            window.location.href = url
          } catch (error) {
            console.error("Failed to create the external certificate checkout session:", error)
            closeModal()
          }
        },
      })
    },
    [openModal, closeModal, userId]
  )

  return { handleOpenExternalCertificateCheckout }
}

export default useExternalCertificateCheckoutModal
